import Home from "../../pages/Home";
import PropertySearchList from "../Property/PropertySearchList";
import PropertyDetails from "../Property/PropertyDetails";
import PromotionDetails from "../Promotion/PromotionDetails";
import Promotions from "../../pages/Promotions";
import SellForm from "../Contact/SellForm/SellForm";
import SatisfactionForm from "../Contact/SatisfactionForm";
import Team from "../../pages/Team";
import Screen from "../../pages/Screen";
import {Route} from "react-router-dom";
import Page from "../../Page";
import React from "react";
import Sent from "../Contact/SellForm/Sent";
import TermsAndConditions from "../../pages/TermsAndConditions";
import PrivacyPolicy from "../../pages/PrivacyPolicy";
import Redirect from "../Redirect";
import Blog from "../../pages/Blog";

export class RoutingHelper {
    static ROUTES = [
        {id: "home",index: true, element: Home},
        {id: "appartements",path: "/nos-appartements", component: PropertySearchList, title: "Nos appartements", props: {types: ["apartment"]}},
        {id: "maisons",path: "/nos-maisons", component: PropertySearchList, title: "Nos maisons", props: {types: ["house"]}},
        {id: "vente",path: "/vente", component: PropertySearchList, props: {actionType: "Acheter"}, children: [
                {path: "/promotions", component: Promotions, title: "Nos promotions", children: [
                    {path: "/:city", component: PropertySearchList, props: {cities: []}, children: [
                            {path: "/:promotionname", component: PromotionDetails, props: {types: []}, children: [
                                {path: "/:propertyname", component: PropertyDetails}
                            ]}
                    ]},
                ]},
                {path: "/:type", component: PropertySearchList, props: {types: []}, children: [
                    {path: "/:city", component: PropertySearchList, props: {cities: []}, children: [
                            {path: "/:propertyname", component: PropertyDetails}
                    ]}
                ]}
            ]},
        {id: "location",path: "/location", component: PropertySearchList, props: {actionType: "Louer"}, children: [
                {path: "/promotions/:city", component: PropertySearchList, props: {cities: []}, children: [
                        {path: "/:promotionname", component: PromotionDetails, props: {types: []}}
                    ]
                },
                {path: "/:type", component: PropertySearchList, props: {types: []}, children: [
                        {
                            path: "/:city", component: PropertySearchList, props: {cities: []}, children: [
                                {path: "/:propertyname", component: PropertyDetails}
                            ]
                        }
                    ]
                }
            ]},
        {id: "annonces",path: "/annonces", component: PropertySearchList, title: "Toutes nos annonces"},
        {id: "promotions",path: "/promotions", component: Promotions, title: "Nos promotions"},
        {id: "estimation",path: "/estimation-bien-immobilier", component: SellForm, title: "Découvrez la réelle valeur de votre bien immobilier"},
        {id: "estimation-envoyee",path: "/estimation-bien-immobilier-envoyee", component: Sent, title: "Votre demande d’estimation a bien été enregistrée !"},
        {id: "recherche",path: "/recherche", component: PropertySearchList, title: "Votre recherche"},
        {id: "vendus",path: "/vendus", component: PropertySearchList, title: "Vendus", props: {sold: true}},
        {id: "satisfaction",path: "/formulaire-satisfaction", component: SatisfactionForm, title: "Formulaire de satisfaction"},
        {id: "equipe",path: "/equipe", component: Team, title: "Notre équipe"},
        {id: "vitrine",path: "/vitrine/:id", element: Screen},
        {id: "conditions-generales",path: "/conditions-generales-dutilisation", component: TermsAndConditions, title: "Conditions générales d'utilisation"},
        {id: "politique-confidentialite",path: "/politique-de-confidentialite", component: PrivacyPolicy, title: "Politique de confidentialité"},
        {id: "blog",path: "/blog", component: Blog, title: "Blog"},
        {id: "propriete_old",path: "/propriete", element: Redirect},
        {id: "promotion_old",path: "/promotion/:promotionref", element: Redirect, children: [
                {path: "/projet", element: Redirect},
                {path: "/propriete", element: Redirect},
            ]},
        {id: "vente_old",path: "/acheter", element: Redirect},
        {id: "location_old",path: "/louer", element: Redirect},
        {id: "estimation_old",path: "/vendre", element: Redirect},
        {id: "satisfaction_old",path: "/contact/satisfaction", element: Redirect},
    ];

    static getRoutes() {
        let routes = [];

        for (const route of this.ROUTES) {
            this.getRoute(routes, route);
        }

        return routes;
    }

    static getRoute(routes, route, parentPath = "", parentProps = {}) {
        let path = (!route.index ? parentPath + route.path : undefined);
        let props = {...parentProps, ...route.props};
        let routeObj = {...route};
        if (path)
            routeObj.path = path;

        if (props !== {})
            routeObj.props = props;

        routes.push(routeObj);

        if ("children" in route) {
            for (let child of route.children) {
                this.getRoute(routes, child, path, props);
            }
        }
    }

    static createRouteElement(route, index) {
        if (route.index) {
            return <Route key={index} index element={<route.element/>}/>;
        } else {
            if ("element" in route) {
                return <Route key={index} path={route.path} element={<route.element/>}/>
            } else {
                let element = <Page {...route} />
                return <Route key={index} path={route.path} element={element}/>
            }
        }
    }

    static getMenuLinks() {
        return [
            {url: this.getPath("home"), title: "Agence immobilière"},
            {url: this.getPath("equipe"), title: "Notre équipe"},
            {url: this.getPath("estimation"), title: "Estimation immobilière"},
            {url: this.getPath("appartements"), title: "Nos appartements"},
            {url: this.getPath("maisons"), title: "Nos maisons"},
            {url: this.getPath("location"), title: "Louer"},
            {url: this.getPath("vendus"), title: "Vendus"},
            {url: this.getPath("blog"), title: "Blog"},
        ];
    }

    static getPath(id){
        const route = this.ROUTES.find((route) => route.id === id);

        return (route && route.path) ? route.path : "/";
    }

    static on(id){
        return this.ROUTES.find((route) => route.id === id)?.path === window.location.pathname;
    }

    static getNewPath(oldPath) {
        return this.getPath(this.ROUTES.find((route) => route.path === oldPath).id.split("_old")[0]);
    }
}